module.exports = __webpack_public_path__ + "img/background-image.5339973f.svg";